import { FieldMetaState } from 'react-final-form';

export function isInvalid<T>(meta: FieldMetaState<T>): boolean {
    return (
        (meta.data?.forceDisplayError && meta.invalid) ||
        (meta.touched && !meta.pristine && meta.invalid) ||
        false
    );
}
